import React from "react";
import { Grid, Card, Typography, Box } from "@mui/material";


function EmployeeComponent() {
    return(<></>);
}

export default EmployeeComponent;